export class Authority {               
    public authority: string;
    public description: string;
    
    constructor (authority:string,description:string){
            this.authority=authority;
            this.description=description;
    }
    
}